import { Translate, Norwegian, English } from '../../components/languageContext'
import styleBreakpoints from '../../styleBreakpoints'
import React, { Component } from 'react'
import TopBar from '../../components/TopBar'
import BottomBar from '../../components/BottomBar'
import './HomePage.css'
import '../styles.css'

const textDigitalDommeKraft = `Et samtaleverktøy for møter og temakvelder med foreldre og foresatte til barn i barnehagen og 1.- 4. trinn.`
const textSpillNO =
'Et spill der barn og voksne sammen skal finne gode måter å håndtere den digitale hverdagen!'
  const textSpillEN =
  'A game where children and adults can work together to figure out the digital world in everyday life.'
class HomePage extends Component {
  componentWillMount() { }

  readMore = () => {
    const { history } = this.props
    history.push({ pathname: '/om', search: history.location.search })
  }

  tryGame = () => {
    window.location =
      'https://spill.dommekraft.no' + this.props.history.location.search
  }
  readMoreGame = () => {
    const { history } = this.props
    history.push({ pathname: '/spill', search: history.location.search })
  }
  style() {
    const logo = {
      height: 154,
      width: 600,
    }
    const superboy = {
      width: 75,
      height: 170,
    }
    const supergirl = {
      width: 85,
      height: 192,
    }
    const textDigitalDommeKraftSize = 20
    const leftColumnWidth = 381
    const button = {
      width: 174,
      height: 60,
      fontSize: 22,
      marginTop: 50,
    }
    const spacerMarginBottom = 25
    const minButtonScale = 0.8

    const css = styleBreakpoints(
      { fullWidth: 1400, fullHeight: 1500 },
      scale => {
        const buttonScale = scale < minButtonScale ? minButtonScale : scale
        scale = 1
        return `
        .HomePage-digital-dommekraft-logo {
          height: ${logo.height * scale}px;
          width: ${logo.width * scale}px;
        }
        .HomePage-supergirl {
          height: ${supergirl.height * scale}px;
          width: ${supergirl.width * scale}px;
        }
        .HomePage-superboy {
          height: ${superboy.height * scale}px;
          width: ${superboy.width * scale}px;
        }
        .HomePage-title {
          font-size: ${textDigitalDommeKraftSize}px;
          width: 600px;
          text-align: center;
          margin-top: 10px;
        }
        .HomePage-spacer
        {
          width: ${leftColumnWidth * scale}px;
        }
        .HomePage-spacer {
          margin-bottom: ${spacerMarginBottom * scale}px;
        }
        ${navigator.userAgent.indexOf('Trident/') !== -1
            ? '' // For some ultra weird reason, IE fails if including these styles..
            : `
          .HomePage-button {
            width: ${button.width * buttonScale}px;
            height: ${button.height * buttonScale}px;
            font-size: ${button.fontSize * buttonScale}px;
          }
        `
          }
      `
      },
    )

    return css
  }

  internetExplorerStyle() {
    return styleBreakpoints(
      { fullWidth: 11000, fullHeight: 1400 },
      scale => `
        .HomePage-elements-container {
          zoom: ${scale};
        }
      }
    `,
    )
  }

  render() {
    return (
      <div className="OuterContainer">
        <style>
          {navigator.userAgent.indexOf('Trident/') !== -1 && false
            ? this.internetExplorerStyle()
            : this.style()}
        </style>
            < div className="HomePage-root-container">
        <TopBar activePage={'Hjem'} />
        <div className="HomePage-container">
            <div className="HomePage-inner-container  HomePage-scale HomePage-mobile-flex">
            <div className="Column">
                <img
              className="HomePage-digital-dommekraft-foreldre"
              src={require('./static/foreldre.png')}
              alt="Digital Dømmekraft"
                />
                <div className="HomePage-title">{textDigitalDommeKraft}</div>
              <div className="Row">
                  <button
              className="HomePage-button HomePage-button-safari"
              onClick={this.readMore}
                  >
                    <Translate>
              <Norwegian>Les mer</Norwegian>
              <English>Read more</English>
            </Translate>
          </button>
      </div >
            </div>   
      <div className="Column HomePage-safari-transform">
        <div className="HomePage-imagesContainer">
          <img
            className="HomePage-left-image"
            src={require('./static/some-luna-noah-nologo.png')}
            alt=""
          />
          <img
            className="HomePage-right-image"
            src={require('./static/stjernekolonien-logo.svg')}
            alt=""
          />
        </div>
        <div className="HomePage-title">
          <Translate>
            <Norwegian>{textSpillNO}</Norwegian>
            <English>{textSpillEN}</English>
          </Translate>
        </div>
        <div className="Row">
          <button className="HomePage-button" onClick={this.tryGame}>
            <Translate>
              <Norwegian>Prøv spillet</Norwegian>
              <English>Try the game</English>
            </Translate>
          </button>
          <button className="HomePage-button" onClick={this.readMoreGame}>
            <Translate>
              <Norwegian>Les mer</Norwegian>
              <English>Read more</English>
            </Translate>
          </button>
        </div>
      </div>
          </div >
        </div >
        </div >
      <BottomBar fixed />
      </div >
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// ./src/pages/HomePage/index.js